import { createFileRoute, redirect } from '@tanstack/react-router';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/EnterpriseIntegration/Index/$integrationId')(
    {
        beforeLoad: ({ params: { currentEnterpriseId, integrationId } }) => {
            if (isCurrentProfilePlatformAdmin()) {
                throw redirect({ to: '/$currentEnterpriseId/Dashboard/Index', params: { currentEnterpriseId } });
            }

            throw redirect({
                to: '/$currentEnterpriseId/EnterpriseIntegration/Marketplace',
                params: { currentEnterpriseId },
                search: { OwnerId: currentEnterpriseId, ApplicationId: integrationId },
            });
        },
        staticData: {
            owner: MewsTeam.ActivationExperience,
            type: RouteType.Frontend,
        },
    }
);
